/**
    Model to assign the data of the Triatlón pre-sale Service
*/
export default class SaleService {
    constructor(product) {
        this.ParkID = product.parkId || 0;
        this.ServiceNumber = product.serviceNumber || 0;
        this.ReferenceSivexID = product.sivexId || 0;
        this.SivexBusinessUnit = product.sivexBusinessUnit || 0;
        this.ServiceID = product.serviceId || "";
        this.ServiceName = product.serviceName || "";
        this.Promotions = product.promotions || [];
    }
}